import { Dialog, DialogActions, DialogContent, DialogTitle, TextField, Button, Typography } from '@mui/material';
import React, { useState } from 'react';
import { useTranslation } from "react-i18next";
import TinyCustomFallback from 'components/Custom/TinyCustomFallback'; 
import "../../css/components/Modals/AddWorkspaceMember.css";
import "../../css/main.css";

const NewWorkspaceMemberModal = ({ openNewWorkSpaceMemberModal, handleNewWorkSpaceMemberModalClose, handleSendInvite, workspace_name, avoidMisfire }) => {
    const { t } = useTranslation();

    const [email, setEmail] = useState('');
    const [isValidEmail, setIsValidEmail] = useState(true);
    const [loading, setLoading] = useState(false); // Loading state

    const handleInvite = async () => {
        if (isValidEmail) {
            setLoading(true); // Set loading to true when sending
            await handleSendInvite(email); // Wait for the invite function to finish
            setLoading(false); // Set loading back to false after invite is sent
        }
    };

    const handleEmailChange = (e) => {
        const inputEmail = e.target.value;
        setEmail(inputEmail);

        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        const isValid = emailPattern.test(inputEmail) || inputEmail === ''; // Allow empty email field
        setIsValidEmail(isValid);
    };

    return (
        <Dialog open={openNewWorkSpaceMemberModal} onClose={handleNewWorkSpaceMemberModalClose} className="modal-background-color" aria-labelledby="new-workspace-member-dialog-title">
            <DialogTitle id="new-workspace-member-dialog-title" className="white-txt-color">{t("modal.workspace_invite")} {workspace_name}</DialogTitle>
            <DialogContent>
                <TextField
                    autoFocus
                    margin="dense"
                    id="email"
                    label={t("modal.user_email")}
                    type="email"
                    fullWidth
                    value={email}
                    onChange={handleEmailChange}
                    error={!isValidEmail && email !== ''} 
                    helperText={!isValidEmail && email !== '' ? t("modal.invalid_email") : ''}
                    InputLabelProps={{
                        className: "white-txt-color"
                    }}
                    InputProps={{
                        className: "white-txt-color"
                    }}
                />
                <Typography variant="body2">{t("modal.user_invite")}</Typography>
            </DialogContent>
            <DialogActions className="add-member-actions">
                <Button onClick={() => { handleNewWorkSpaceMemberModalClose(); setEmail(''); }} className="button-dark-bg">
                    {t("global.cancel")}
                </Button>
                <Button
                    onClick={handleInvite}
                    disabled={!isValidEmail || email === '' || avoidMisfire || loading} 
                    className="button-dark-bg"
                    sx={{maxHeight:"36.48px", minHeight:"36.48px"}}
                >
                    {loading ? (
                        <>
                            {t("modal.sending")} 
                            <TinyCustomFallback sx={{marginRight:"5px"}} /> 
                        </>
                    ) : (
                        t("modal.invite") 
                    )}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default NewWorkspaceMemberModal;
